import { McpServer, RepoburgMcpServer, RepoburgMcpGateway, InitiateConnectResponse } from '@/types/api';
import { getApiBaseUrl, handleResponse } from './client';

const API_URL = getApiBaseUrl();
const DAEMON_BASE_URL = 'http://localhost:9998';

export async function getMcpServers(): Promise<McpServer[]> {
  const response = await fetch(`${API_URL}/mcp/servers`);
  return handleResponse<McpServer[]>(response);
}

export async function getRepoburgMcpServer(): Promise<RepoburgMcpServer> {
  const response = await fetch(`${API_URL}/mcp/repoburg-server`);
  return handleResponse<RepoburgMcpServer>(response);
}

export async function getRepoburgMcpGateway(): Promise<RepoburgMcpGateway> {
  const response = await fetch(`${DAEMON_BASE_URL}/mcp-gateway-info`);
  return handleResponse<RepoburgMcpGateway>(response);
}

export interface RepoburgMcpServerStatus {
  running: boolean;
  port: number;
  host: string;
  url: string;
}

export async function startRepoburgMcpServer(): Promise<RepoburgMcpServerStatus> {
  const response = await fetch(`${API_URL}/mcp/repoburg-server/start`, {
    method: 'POST',
  });
  return handleResponse<RepoburgMcpServerStatus>(response);
}

export async function stopRepoburgMcpServer(): Promise<RepoburgMcpServerStatus> {
  const response = await fetch(`${API_URL}/mcp/repoburg-server/stop`, {
    method: 'POST',
  });
  return handleResponse<RepoburgMcpServerStatus>(response);
}

export async function createMcpConfig(configJson: string): Promise<McpServer> {
  const response = await fetch(`${API_URL}/mcp/configs`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ configJson }),
  });
  return handleResponse<McpServer>(response);
}

export async function updateMcpConfigStatus(
  serverName: string,
  isActive: boolean,
): Promise<void> {
  const response = await fetch(`${API_URL}/mcp/configs/${serverName}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ is_active: isActive }),
  });
  return handleResponse<void>(response);
}

export async function deleteMcpConfig(serverName: string): Promise<void> {
  const response = await fetch(`${API_URL}/mcp/configs/${serverName}`, {
    method: 'DELETE',
  });
  return handleResponse<void>(response);
}

export async function batchUpdateToolStatus(
  toolKeys: string[],
  isActive: boolean,
): Promise<{ affected: number }> {
  const response = await fetch(`${API_URL}/mcp/tools`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ toolKeys, is_active: isActive }),
  });
  return handleResponse<{ affected: number }>(response);
}

/**
 * Re-authorize an existing remote MCP server whose token has expired.
 * Returns the authorization URL that the frontend should open in the browser,
 * same as the marketplace connect flow.
 */
export async function reconnectMcpServer(
  serverName: string,
): Promise<InitiateConnectResponse> {
  const response = await fetch(`${API_URL}/mcp/reconnect/${serverName}`, {
    method: 'POST',
  });
  return handleResponse<InitiateConnectResponse>(response);
}